module.exports = __webpack_public_path__ + "static/img/gaotanglingshi.1b3f9174.png";